import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import _ from "underscore";
import BreadcrumbPill from "web/react/components/breadcrumb-pill/breadcrumb-pill";
import { AllSelectedFilterInfo, FilterClickHandler } from "web/types/feed-filters";
import { BaseFilterOption, UniversalFilterOption } from "web/types/universal-filters";
import styles from "./feeds-filters-breadcrumb-pills.css";

interface BreadcrumbPillProps {
    selectedFilterInfo: AllSelectedFilterInfo;
    onClick: FilterClickHandler;
    className?: string;
}

function BreadcrumbPills({
    className,
    onClick,
    selectedFilterInfo,
}: BreadcrumbPillProps): null | JSX.Element {
    let selectedOptions: UniversalFilterOption[] =
        // Collapse the sections into one big ole list of crumbs
        _.flatten(
            Object.values(selectedFilterInfo).map((section) => section.breadcrumbs),
            true
        )
            // Make sure the pair_of_selects range breadcrumb doesn't show up
            .filter((option: BaseFilterOption) => !option.disabled);

    return (
        <ul className={classnames(styles.pills, className)}>
            {selectedOptions.map((option) => (
                <li className={styles.pill} key={`${option.name}=${option.value}`}>
                    <BreadcrumbPill
                        onClick={(): void => onClick(option, true)}
                        title={option.label}
                        href={option.url}
                    />
                </li>
            ))}
        </ul>
    );
}

export default BreadcrumbPills;

BreadcrumbPills.propTypes = {
    selectedFilterInfo: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired,
};
